<template>

    <div>
        <v-row no-gutters>
            <base-header>
                <div slot="page-header">Exchange Transaction</div>
            </base-header>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12" lg="3" xl="3">
                <card-search></card-search>
            </v-col>
            <v-col cols="12" lg="9" xl="9">
                <v-card class="pa-2 ma-2" outlined tile>
                    <v-card-text>
                        <chart-trader></chart-trader>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        <v-row no-gutters>
         <v-col cols="12" sm="6" lg="6">
                <card-money></card-money>
            </v-col>
            <v-col cols="12" sm="6" lg="6">
                <card-transaction></card-transaction>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="12">
                <card-slide-group></card-slide-group>
            </v-col>
        </v-row>
        

    </div>
</template>

<script>
    import BaseCard from "../../components/Base/BaseCard.vue";
    import BaseHeader from "../../components/Base/BaseHeader.vue";
    import CardTransaction from '../../components/Cards/CardTransaction'
    import CardTab from '../../components/Cards/CardTab'
 
    import ChartTrader from '../../components/Charts/ChartTrader'
    import CardSlideGroup from '../../components/Cards/CardSlideGroup'
    import CardSearch from '../../components/Cards/CardSearch.vue'
import CardMoney from '../../components/Cards/CardMoney'
    export default {
        components: {
            BaseCard,
            BaseHeader,
            CardTransaction,
            CardTab,
   
            ChartTrader,
            CardSearch,
            CardSlideGroup,CardMoney

        },
    }
</script>